<backbone>
  <section header-page="topbar" class="d-flex justify-content-between gap-2 h-100 position-relative">
    <div class="d-flex justify-content-start align-items-center text-truncate">
      <p class="m-0 fw-medium text-truncate text-truncate">Lista de usuarios</p>
    </div>

    <div class="d-flex justify-content-end align-items-center gap-3">
      <breadcrumb [items]="[{ label: 'Lista de usuarios' }]" />

      <a class="btn btn-primary h-100 d-flex flex-column justify-content-center" routerLink="settings">Configuraciones</a>
      <a class="btn btn-success text-white h-100 d-flex flex-column justify-content-center" routerLink="create">Nuevo</a>
    </div>
  </section>

  <section wrapper>
    <div class="page-section card">
      <div class="card-body p-0">
        @if (this.isLoading === false) {
        <p-table
          #dt1
          [value]="users"
          [rows]="25"
          [rowsPerPageOptions]="[25, 50, 100]"
          [paginator]="true"
          [globalFilterFields]="['nickname', 'firstName', 'lastName']"
          [tableStyle]="{ 'min-width': '50rem' }"
          dataKey="userId"
          groupRowsBy="userId"
          (onRowExpand)="onRowExpand($event)"
          (onRowCollapse)="onRowCollapse($event)"
        >
          <ng-template pTemplate="caption">
            <div class="d-flex flex-xl-row gap-2">
              <div class="w-100">
                <p-inputgroup>
                  <p-iconfield class="w-100">
                    <p-inputicon styleClass="pi pi-search" />
                    <input
                      type="text"
                      pInputText
                      [(ngModel)]="searchValue"
                      (input)="dt1.filterGlobal(searchValue, 'contains')"
                      placeholder="Buscar por nombre, apellidos, sobrenombre."
                      class="w-100 h-50px rounded-end-0"
                    />
                  </p-iconfield>
                  <p-inputgroup-addon *ngIf="searchValue" pTooltip="Limpiar busqueda">
                    <p-button icon="pi pi-times" severity="secondary" class="h-100" styleClass="h-100" (click)="searchValue = ''; dt1.filterGlobal(searchValue, 'contains')" />
                  </p-inputgroup-addon>
                </p-inputgroup>
              </div>
            </div>

            @if (breadcrumbUsers.length > 0) {
            <div class="d-flex gap-2 mt-2">
              <p-chip label="Todos" (click)="getUsers()" role="button" />

              @for (item of breadcrumbUsers; track $index) {
              <p-chip [label]="item.nickname" (click)="getParentUser(item.userId, item.nickname, $index)" role="button" />
              }
            </div>
            }
          </ng-template>

          <ng-template pTemplate="header">
            <tr>
              <th></th>
              <th>Nombre</th>
              <th>Correo electrónico</th>
              <th>Sobrenombre</th>
              <th>Rol</th>
              <th>N. Sesiones</th>
              <th>Estado</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-item let-expanded="expanded">
            <tr>
              <td style="width: 35px">
                <p-button type="button" pRipple [pRowToggler]="item" [text]="true" [rounded]="true" [plain]="true" [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'" />
              </td>
              <td class="text-nowrap">
                <a routerLink="details/{{ item.username }}">{{ item.firstName }} {{ item.lastName }}</a>
              </td>
              <td class="text-nowrap">
                {{ item.email }}
              </td>
              <td class="text-nowrap">
                {{ item.nickname }}
              </td>
              <td class="text-nowrap">
                <p-tag [value]="findRole(item.roleId)?.label" [severity]="'secondary'" class="fw-normal" />
              </td>
              <td class="text-nowrap">
                <p-tag [severity]="item.numberSessionsActive > 0 ? 'success' : 'secondary'" class="fw-normal">
                  <div class="d-flex gap-1 justify-content-center">
                    <span>{{ item.numberSessionsActive }}</span>

                    <span>de</span>

                    @if (item.numberSessions !== null) {
                    <span>{{ item.numberSessions }}</span>
                    } @else {
                    <span class="fs-5 lh-1"><i class="bi bi-infinity"></i></span>
                    }
                  </div>
                </p-tag>
              </td>
              <td class="text-nowrap">
                <p-tag [value]="item.status === 'ACTIVE' ? 'Activo' : 'Inactivo'" [severity]="item.status === 'ACTIVE' ? 'success' : 'secondary'" class="fw-normal" />
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="expandedrow" let-item>
            <tr>
              <td></td>
              <td class="small">Colaboradores</td>
              <td class="small" colspan="5">
                <p-button label="Ver colaboradores" severity="secondary" size="small" (click)="getParentUser(item.userId, item.nickname)" />
              </td>
            </tr>
            <tr>
              <td></td>
              <td class="small">Fecha de creación</td>
              <td class="small text-nowrap" colspan="5">
                {{ item.dateCreated | date : "longDate" }}
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td [attr.colspan]="7" class="text-center">No se encontraron registros.</td>
            </tr>
          </ng-template>
        </p-table>
        } @else {
        <placeholder-table [header]="['Nombre', 'Correo electrónico', 'Sobrenombre', 'Rol', 'N. Sesiones', 'Estado']" />
        }
      </div>
    </div>
  </section>
</backbone>
